import React from 'react';
import MuiTypography from '@mui/material/Typography';

const Typography = (props) => <MuiTypography {...props} />;

export default Typography;
